import ChevronIcon from 'components/assets/ChevronIcon';
import A from 'components/atoms/A/A';
import Heading from 'components/atoms/Heading/Heading';
import Txt from 'components/atoms/Txt/Txt';
import PaypalRequiredModal from 'components/molecules/PaypalRequiredModal/PaypalRequiredModal';
import RedemptionOptionItem from 'components/organisms/RedemptionOptions/RedemptionOptionItem';
import { REWARDS } from 'components/pages/pages';
import { useRouter } from 'next/router';
import React from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';
import { PayPalRewardsQuery } from './__generated__/PayPalRewardsQuery.graphql';
import classes from './PayPalRewards.module.scss';

export type Props = {};

const query = graphql`
  query PayPalRewardsQuery($redemptionType: RedemptionTypeKey!, $redirectUrl: String!) {
    redemptionTypes {
      types {
        name
        linkNewAccountUrl(input: { redirectUrl: $redirectUrl })
        status
      }
    }
    redemptionOptions(input: { redemptionType: $redemptionType }) {
      edges {
        node {
          id
          name
          amountDenominations {
            panelistCost {
              subUnitAmount
            }
          }
          ...useRedemptionOptionItemQuery_optionRef
        }
      }
    }
  }
`;

export default function PayPalRewards() {
  const router = useRouter();
  const redemptionOptions = useLazyLoadQuery<PayPalRewardsQuery>(
    query,
    { redemptionType: 'PAYPAL', redirectUrl: window.location.href },
    {
      fetchPolicy: 'store-and-network',
    },
  );

  const payPalRedemptionType = redemptionOptions.redemptionTypes?.types.find(
    (type) => type.name === 'PAYPAL',
  );

  function handleCloseModal() {
    router.push(REWARDS.path);
  }

  return (
    <div className={classes.root}>
      <div className={classes.infoContent}>
        <A className={classes.backLink} href={REWARDS.path} aria-label="Back to Rewards">
          <ChevronIcon className={classes.backLinkChevron} />
        </A>
        <Heading level="1" className={classes.title}>
          PayPal Rewards
        </Heading>
        <Txt component="p" className={classes.description}>
          Choose your reward from the list below
        </Txt>

        {payPalRedemptionType?.linkNewAccountUrl && (
          <A
            className={classes.link}
            href={payPalRedemptionType.linkNewAccountUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Txt>Link new PayPal account</Txt>
          </A>
        )}
      </div>

      <ul className={classes.rewardList}>
        {/* We can re-add filters when necessary (see RedemptionOptions in LP repo) */}
        {redemptionOptions?.redemptionOptions?.edges.map(({ node }) => (
          <RedemptionOptionItem redemptionType={'PAYPAL'} key={node.id} optionRef={node} />
        ))}
      </ul>

      {!redemptionOptions?.redemptionOptions?.edges.length &&
        payPalRedemptionType?.linkNewAccountUrl && (
          <PaypalRequiredModal
            onClose={handleCloseModal}
            linkAccountUrl={payPalRedemptionType.linkNewAccountUrl}
          />
        )}
    </div>
  );
}
